namespace Areas.Contact.Profile {
    "use strict";

    let currentContactPhone: any;

    export function onNewContactPhoneRow(e: any) {
        currentContactPhone = e.data;
        currentContactPhone.contactId = e.component.option("ContactId");
    }
}